import { SubscriptionInfo } from "@cloudextend/cefi/core";
import { declareEvent, args } from "@cloudextend/common/events";

export const subscriptionUpdated = declareEvent(
    "CEFI: Subscription Updated",
    args<{ subscription: SubscriptionInfo }>()
);
